/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for password change endpoint.
 * @export
 * @interface APIPatchedChangePasswordRequest
 */
export interface APIPatchedChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedChangePasswordRequest
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedChangePasswordRequest
     */
    password2?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedChangePasswordRequest
     */
    passwordOld?: string;
}

/**
 * Check if a given object implements the APIPatchedChangePasswordRequest interface.
 */
export function instanceOfAPIPatchedChangePasswordRequest(value: object): value is APIPatchedChangePasswordRequest {
    return true;
}

export function APIPatchedChangePasswordRequestFromJSON(json: any): APIPatchedChangePasswordRequest {
    return APIPatchedChangePasswordRequestFromJSONTyped(json, false);
}

export function APIPatchedChangePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedChangePasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'] == null ? undefined : json['password'],
        'password2': json['password_2'] == null ? undefined : json['password_2'],
        'passwordOld': json['password_old'] == null ? undefined : json['password_old'],
    };
}

export function APIPatchedChangePasswordRequestToJSON(value?: APIPatchedChangePasswordRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'password': value['password'],
        'password_2': value['password2'],
        'password_old': value['passwordOld'],
    };
}

